import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useEmployees } from "../Provider";
import BoxInfo from "./BoxInfo";

function InfoEmployee() {
  const { id } = useParams();
  const {
    state: { selected: employee },
    fetchOne: fetchEmployee,
  } = useEmployees();

  const fetchEmployeeRef = useRef(fetchEmployee);
  fetchEmployeeRef.current = fetchEmployee;

  useEffect(() => {
    fetchEmployeeRef.current(id);
  }, [id]); 

  if (!employee)
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress color="inherit" size="2rem" />
      </Box>
    );

  return (
    <>
      <Typography variant="Poster" component="h4">
        Employee Details
      </Typography>
      <BoxInfo employee={employee} />
    </>
  );
}

export default InfoEmployee;
